import { Link } from 'react-router-dom';

interface Props {
  title?: string;
  description?: string;
  resetLabel?: string;
  resetTo?: string;
  onReset?: () => void;
}

export default function EmptyState({
  title = '暂无符合条件的影视作品',
  description = '试试调整筛选条件，或更换关键词重新查找。',
  resetLabel = '重置筛选',
  resetTo,
  onReset,
}: Props) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-film-line text-2xl w-7 h-7 flex items-center justify-center" />
      </span>
      <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-sm text-sm leading-relaxed text-foreground-600">{description}</p>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-5 inline-flex h-9 items-center gap-1.5 rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line w-4 h-4 flex items-center justify-center" />
          {resetLabel}
        </button>
      )}
      {!onReset && resetTo && (
        <Link
          to={resetTo}
          className="mt-5 inline-flex h-9 items-center gap-1.5 rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          {resetLabel}
        </Link>
      )}
    </div>
  );
}